import Vue from "vue";
import VueRouter from "vue-router";
import SelectCity from "@/views/SelectCity.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/home/:cityId",
    name: "Home",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "home" */ "../views/Home.vue")
  },

  {
    path: "/nearby/:cityId",
    name: "Nearby",
    component: () =>
      import(/* webpackChunkName: "nearby" */ "../views/store/Nearby.vue")
  },

  {
    path: "/store/:storeId",
    name: "Store",
    component: () =>
      import(/* webpackChunkName: "store" */ "../views/store/Store.vue")
  },

  {
    path: "/addStore",
    name: "AddStore",
    component: () =>
      import(/* webpackChunkName: "addStore" */ "../views/store/AddStore.vue")
  },

  {
    path: "/editStore/:storeId",
    name: "EditStore",
    component: () =>
      import(/* webpackChunkName: "editStore" */ "../views/store/EditStore.vue")
  },

  {
    path: "/discounts/:cityId",
    name: "Discounts",
    component: () =>
      import(
        /* webpackChunkName: "discounts" */ "../views/discount/Discounts.vue"
      )
  },

  {
    path: "/discount/:discountId",
    name: "Discount",
    component: () =>
      import(
        /* webpackChunkName: "discount" */ "../views/discount/Discount.vue"
      )
  },

  {
    path: "/addDiscount",
    name: "AddDiscount",
    component: () =>
      import(
        /* webpackChunkName: "addDiscount" */ "../views/discount/AddDiscount.vue"
      )
  },

  {
    path: "/editDiscount/:discountId",
    name: "EditDiscount",
    component: () =>
      import(
        /* webpackChunkName: "editDiscount" */ "../views/discount/EditDiscount.vue"
      )
  },

  {
    path: "/events/:cityId",
    name: "Events",
    component: () =>
      import(/* webpackChunkName: "events" */ "../views/event/Events.vue")
  },

  {
    path: "/event/:eventId",
    name: "Event",
    component: () =>
      import(/* webpackChunkName: "event" */ "../views/event/Event.vue")
  },

  {
    path: "/favorites/:cityId?",
    name: "Favorites",
    component: () =>
      import(/* webpackChunkName: "favorites" */ "../views/Favorites.vue")
  },

  {
    path: "/legal-notice/",
    name: "LegalNotice",
    component: () =>
      import(/* webpackChunkName: "legalNotice" */ "../views/LegalNotice.vue")
  },

  {
    path: "/privacy/",
    name: "Privacy",
    component: () =>
      import(/* webpackChunkName: "privacy" */ "../views/Privacy.vue")
  },

  {
    path: "/:noRedirect?",
    name: "SelectCity",
    component: SelectCity
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  }
});

export default router;
